import React, { useContext, useState, useEffect } from "react";
import { store } from "../store";
import { Row, Col } from 'antd';
import { Text, View, FlatList, Pressable, ScrollView, TextInput } from 'react-native-web';
import { themeColor } from "../config/servervar";
import { ViewList, ViewDetail } from '../component/listdetail';
import axios from 'axios'
import { server_var } from "../config/servervar";

const LIST_DEFINE = [
  { id: 1, field1: 'id', flex: 0.1, textAlign: 'left', headerTitle: 'ID' },
  { id: 2, field1: 'user', field2: 'displayName', flex: 0.2, headerTitle: 'ลูกค้า' },
  { id: 3, field1: 'pharmacist', field2: 'displayName', flex: 0.2, headerTitle: 'เภสัช' },
  { id: 4, field1: 'shop', field2: 'shopThName', flex: 0.2, headerTitle: 'ร้าน' },
  { id: 5, field1: 'startTime', flex: 0.2, headerTitle: 'วันเวลา', controlType: 'datetime' },
];

const DETAIL_DEFINE = [
  {
    id: 1, fieldName: 'id', displayName: 'ID', newValue: 0, controlOption: {
      textInputStyle: { backgroundColor: 'lightgray' }, textInputProp: { editable: false }
    }
  },
  { id: 2, fieldName: 'userId', displayName: 'เบอร์มือถือ', newValue: '' },
];

const QUERY_NAME = 'pharmanotes';
const QUERY_CON = {};

export const Consult = () => {
  const [selectIndex, setSelectIndex] = useState(-1);
  const [queryParams, setQueryParams] = useState();
  const beforeSavePress = async (data) => {
    return { data, errorList: validateData(data) }
  }

  const validateData = (data) => {
    let tmpErrorList = [];
    for (const item of ['mobileNumber', 'firstName', 'lastName']) {
      if (!(data?.[item])) {
        tmpErrorList = [...tmpErrorList, { fieldName: item, errorFlag: true, errorMsg: 'ไม่สามารถเว้นไว้ได้' }]
      }
    }
    return tmpErrorList
  }

  const downloadTxtFile = async () => {
    const res = await axios.post(`${server_var.server_api}/extractPharmanotes`, queryParams)
    if (res?.data?.csv) {
      console.log('texts', res.data.csv);
      const file = new Blob([res.data.csv], { type: 'text/plain' });
      const element = document.createElement("a");
      element.href = URL.createObjectURL(file);
      element.download = "pharmanotes" + Date.now() + ".csv";
      document.body.appendChild(element);
      element.click();
    } else if (res.data.message) {
      alert(res.data.message);
    } else {
      alert('มีข้อผิดพลาดเกิดขึ้น')
    }
  }

  const onChangeQuery = (queryParams) => {
    setQueryParams(queryParams);
  }

  return (
    <Row style={{ flex: 1, flexWrap: 'nowrap' }}>
      <Col span={24} style={{ height: '100vh', padding: 5 }}>
        <ViewList
          onPress={id => setSelectIndex(id)} listDefine={LIST_DEFINE} queryName={QUERY_NAME} queryCon={QUERY_CON}
          onChangeQuery={onChangeQuery}
          viewListOption={{
            hideNew: true, topControlList: [
              { id: 1, title: 'Export', type: 'button', onPress: () => downloadTxtFile() },
              { id: 2, title: 'Search', type: 'multi_column_search', searchField: ['$user.displayName$', '$pharmacist.displayName$', '$shop.shopThName$'], placeholder: 'ค้นหาตามชื่อลูกค้า,ชื่อเภสัช,ชื่อร้าน', textInputStyle: { width: 300 } },
              { id: 3, title: '', type: 'daterange', searchField: 'startTime', placeholder: ['วันเริ่ม', 'วันสิ้นสุด'] },
            ]
          }}
        // viewListOption={{ hideNew: true, topControlList: [{ id: 1, title: 'Search', type: 'search', searchField: ['firstName', 'lastName', 'mobileNumber'] }] }}
        />
      </Col>
      {/* <Col span={12} style={{
        height: '100vh', padding: 5,
        borderWidth: 1, borderLeftStyle: 'solid', borderColor: 'gray'
      }}>
        <ViewDetail
          selectIndex={selectIndex} detailDefine={DETAIL_DEFINE} queryName={QUERY_NAME} onSavePress={(id) => setSelectIndex(-1)}
          beforeSavePress={beforeSavePress}
        />
      </Col> */}
    </Row>
  )
}

